import React from 'react';
import { Box, Image, Flex } from '@chakra-ui/react';
import * as logoImages from './logos';

const logoNames: (keyof typeof logoImages)[] = [
  'akatsuki',
  'jdl',
  'photosynth',
  'topy',
  'qtNet',
  'edwards',
  'voicePing',
  'iwaki',
  'lib',
  'iimon',
  'aisan',
];

const LogoList = (): JSX.Element => (
  <Box display="flex" sx={{ justifyContent: 'center' }}>
    <Flex
      wrap="wrap"
      alignItems="center"
      justifyContent="center"
      bgColor="white"
      maxW="1020px"
      margin={{ base: '15px 10px 0', md: '15px 20px 0' }}
      padding="20px 25px"
      borderRadius="20px"
    >
      {logoNames.map((name) => (
        <Image
          key={name}
          // eslint-disable-next-line import/namespace
          src={logoImages[name]}
          height={{ base: '40px', md: '50px' }}
          alt={name}
          margin={{ base: '10px', md: '20px' }}
        />
      ))}
    </Flex>
  </Box>
);

export default LogoList;
